export { default as Layout } from 'secured/containers/SecuredLayoutContainer';



// WEBPACK FOOTER //
// src/modules/secured/containers/index.js